import { useQuery } from 'react-query';

import { getTagsAssignedToCurrentCustomerSubPrograms as queryFn } from 'api/endPoints/getTagsAssignedToCurrentCustomerSubPrograms';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetTagsAssignedToCurrentCustomerSubPrograms = () => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys]>({
        queryKey: ['getTagsAssignedToCurrentCustomerSubPrograms'],
        queryFn: () => queryFn(),
    });
};

interface QueryResponse {
    id: number;
    name: string;
}
